import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    supplier:{
        name: "",
        address: "",
        phone: "",
        gstNumber: ""

    },
    supplierList:[
        {
            name: "Nihal Deshmukh",
            address: "Karvenagar, Pune",
            phone: "0123456789",
            gstNo: "DKJSDJL545",
        },
        {
            name: "Karan Kamble",
            address: "Hadapsar, Pune",
            phone: "77423456789",
            gstNo: "GJGHJ",
        },
        {
            name: "Deepak Pathak",
            address: "Pimple Nilakh, Pimpri Chinchwad",
            phone: "65489756456",
            gstNo: "KNOSSDD",
        },
        {
            name: "Sanket Jadhav",
            address: "Bhosari, Pune",
            phone: "4565566659",
            gstNo: "SONSOJP",
        },
        {
            name: "Pratik Karne",
            address: "Aundh, Pune",
            phone: "54656456465",
            gstNo: "LKJKL545",
        },
    ]
}

const supplier = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default supplier;